import { Button, FormControl, FormLabel } from '@chakra-ui/react';
import { ModalType } from 'components/modals/types';
import { FC, useEffect, useState } from 'react';
import { FaCaretDown } from 'react-icons/fa';
import { useModal } from 'store/modals';
import { ProgramToken } from 'types';
import { truncate } from 'utils/address';

type Props = {
  tokenList: ProgramToken[];
  setSelectedToken: (token: ProgramToken) => void;
  required?: boolean;
  selectedToken?: ProgramToken;
};

const SelectTokenInput: FC<Props> = ({
  tokenList,
  setSelectedToken,
  required,
  selectedToken
}) => {
  const { openModal, closeModal } = useModal();
  const [selectedTokenSymbol, setSelectedTokenSymbol] = useState('Select');

  const onSelectToken = (token: ProgramToken) => {
    setSelectedToken(token);
    setSelectedTokenSymbol(truncate(token.tokenSymbol.toUpperCase()));
    closeModal(ModalType.selectToken);
  };

  useEffect(() => {
    if (selectedToken) {
      setSelectedTokenSymbol(
        truncate(selectedToken?.tokenSymbol.toUpperCase())
      );
    }
  }, [setSelectedToken, selectedToken]);

  return (
    <FormControl isRequired={required}>
      <FormLabel>Select token</FormLabel>
      <Button
        width='100%'
        variant='outline'
        borderRadius='lg'
        justifyContent='space-between'
        rightIcon={<FaCaretDown />}
        onClick={() => {
          openModal(ModalType.selectToken, {
            tokenList,
            onSelectToken
          });
        }}
      >
        {selectedTokenSymbol}
      </Button>
    </FormControl>
  );
};

export default SelectTokenInput;
